import { FC, HTMLAttributes } from 'react';

import TextBase, { TextProps } from './TextBase';

type Props = HTMLAttributes<HTMLParagraphElement> & Omit<TextProps, 'as'>;

// Component Definition
const Paragraph: FC<Props> = ({
  fontColor = 'inherit',
  fontSize = 16,
  fontWeight = 400,
  uppercase = false,
  ...props
}) => {
  return (
    <TextBase
      {...props}
      as="p"
      fontColor={fontColor}
      fontSize={fontSize}
      fontWeight={fontWeight}
      uppercase={uppercase}
    />
  );
};

export default Paragraph;
